import { render, staticRenderFns } from "./device-bar.vue?vue&type=template&id=55064ad8&"
import script from "./device-bar.vue?vue&type=script&lang=js&"
export * from "./device-bar.vue?vue&type=script&lang=js&"
import style0 from "./device-bar.vue?vue&type=style&index=0&id=55064ad8&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports